import styled from "styled-components";
import { Typography } from "@material-ui/core";

const blue = (props) => props.theme.palette.blue;
const grey = (props) => props.theme.palette.grey;
const opensans = (props) => props.theme.fonts.opensans;
const secondary = (props) => props.theme.palette.secondary;
const montserrat = (props) => props.theme.fonts.montserrat;

export const TypographyStyled = styled(Typography)`
  font-weight: bold !important;
  font-size: 18px !important;
  color: ${blue};
  font-family: ${opensans} !important;
`;

export const FiltrarInadiplentesStyled = styled.div`
  font-family: ${opensans} !important;
  font-size: 14px !important;
  color: ${grey}!important;
  padding: 10px 0px 0px 0px !important;
`;

export const TableContent = styled.div`
  Table {
    min-width: 0px !important;
    Thead {
      background-color: ${secondary};
      box-shadow: 3px 3px 3px ${(props) => props.theme.palette.darkgrey};
      tr {
        th {
          span {
            font-family: ${montserrat}, sans-serif !important;
          }
        }
      }
    }
    Tbody {
      tr {
        height: 0px !important;
      }
      td {
        font-family: ${montserrat}, sans-serif !important;
      }
    }
  }
`;
